/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { createItem, deleteItem, updateItem } from '../graphql';
import createMultiItems from '../graphql/mutation/createMultiItems';
import getCollectiveitems from '../graphql/query/getCollectiveitems';

export default () => {
  const [getsevs, itmData]: any = useLazyQuery(getCollectiveitems);

  const [addCollectiveitem] = useMutation(createItem, {
    refetchQueries: [{ query: getCollectiveitems }],
  });
  const [addMultiCollectiveitems] = useMutation(createMultiItems, {
    refetchQueries: [{ query: getCollectiveitems }],
  });
  const [editCollectiveitem] = useMutation(updateItem, {
    refetchQueries: [{ query: getCollectiveitems }],
  });
  const [removeCollectiveitem] = useMutation(deleteItem, {
    refetchQueries: [{ query: getCollectiveitems }],
  });

  useEffect(() => {
    getsevs();
  }, [getsevs]);

  const collectiveitems = itmData?.data?.['getCollectiveitems']?.data || [];
  const refreshcollectiveitem = () => {
    itmData?.refetch();
  };

  return {
    collectiveitems,
    addCollectiveitem,
    addMultiCollectiveitems,
    editCollectiveitem,
    removeCollectiveitem,
    refreshcollectiveitem,
    loading: itmData?.loading,
  };
};
